import { Navigate } from "react-router-dom";
import ConsoleHelper from "utils/ConsoleHelper";

function RequireGuest({ children, isAuth }) {
  if (isAuth) {
    // If user is logged in, do not let them see this route (e.g., login page).
    // Instead, decide where you want them to go if they’re already logged in:
    // maybe “/auth/verify” or “/subscription” or your main app.
    ConsoleHelper("RequireGuest", "User is already authenticated");
    return <Navigate to="/" replace />;
  }
  return children;
}

export default RequireGuest;
